import { Link } from "react-router-dom";
import { useState } from "react";
import WaitlistDialog from "@/components/WaitlistDialog";

export default function Footer() {
  const [open, setOpen] = useState(false);
  return (
    <footer data-testid="site-footer" className="bg-[#0A0A0A] text-[#FAFAFA] mt-24">
      <div className="container-x py-24 md:py-32 grid grid-cols-1 md:grid-cols-12 gap-12">
        <div className="md:col-span-7">
          <p className="overline text-white/60">Become a design partner</p>
          <h2 className="font-serif text-5xl sm:text-6xl md:text-7xl leading-[0.95] tracking-tighter mt-4 max-w-3xl">
            The future of legal work
            <br />
            <span className="italic text-white/70">starts with intelligence.</span>
          </h2>
          <button
            data-testid="footer-waitlist-btn"
            onClick={() => setOpen(true)}
            className="mt-10 inline-flex items-center px-7 py-3.5 bg-white text-[#0A0A0A] text-sm font-medium hover:bg-[#94A3B8] hover:text-[#0A0A0A] transition-colors"
          >
            Request early access →
          </button>
        </div>

        <div className="md:col-span-5 grid grid-cols-2 gap-10 md:pt-2">
          <div>
            <p className="overline text-white/60 mb-4">Product</p>
            <ul className="space-y-2.5 text-sm text-white/80">
              <li><Link to="/product" className="hover:text-white">ContractIQ</Link></li>
              <li><Link to="/pricing" className="hover:text-white">Pricing</Link></li>
              <li><Link to="/contact" className="hover:text-white">Request a demo</Link></li>
            </ul>
          </div>
          <div>
            <p className="overline text-white/60 mb-4">Company</p>
            <ul className="space-y-2.5 text-sm text-white/80">
              <li><Link to="/about" className="hover:text-white">About Cognita</Link></li>
              <li><Link to="/contact" className="hover:text-white">Contact</Link></li>
              <li><a href="mailto:contact@cognita-ai.com" className="hover:text-white">contact@cognita-ai.com</a></li>
            </ul>
          </div>
        </div>
      </div>

      <div className="border-t border-white/10">
        <div className="container-x py-6 flex flex-col md:flex-row items-start md:items-center justify-between gap-3">
          <p className="text-xs font-mono tracking-[0.18em] uppercase text-white/50">
            © {new Date().getFullYear()} Cognita AI · ContractIQ
          </p>
          <p className="text-xs font-mono tracking-[0.18em] uppercase text-white/40">
            Contract intelligence for the modern law firm
          </p>
        </div>
      </div>

      <WaitlistDialog open={open} onOpenChange={setOpen} />
    </footer>
  );
}
